"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _style = _interopRequireDefault(require("./style.css"));
var _sahara = _interopRequireDefault(require("./sahara.png"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  className: _style["default"].background,
  assets: [_sahara["default"]],
  imageUrl: _sahara["default"],
  thumbnail: _thumbnail["default"]
};